import axios from 'axios';
import CustomerRatingsTable from 'components/tables/CustomerRatingsTable';
import UserWalletTable from 'components/tables/UserWalletTable';
import { errorHandler } from 'helpers/response-utils';
import { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import CustomerProfileCard from './CustomerProfileCard';
import UserNormalPointsReward from './UserNormalPointsReward';
import UserReferralPointsReward from './UserReferralPointsReward';
import UserRewardClaim from './UserRewardClaim';
import SummaryCard from 'components/cards/SummaryCard';
import iconTotalUsers from 'assets/img/icons/01_total_users.svg';
import iconWallet from 'assets/img/icons/02_wallet.svg';

const UserDetails = () => {
  const { id } = useParams();
  const [wmdrSummary, setWmdrSummary] = useState(null);
  const token = localStorage.getItem('token');
  const [userSummary, setUserSummary] = useState({
    total_earned_points: 0,
    claimed_points: 0,
    ref_amount_earned: 0,
    ref_amount_claimed: 0,
    total_token: 0
  });
  const [userDetails, setUserDetails] = useState({
    createdAt: '',
    id: 0,
    userId: '',
    userName: '',
    subscribeEmailId: '',
    isActive: true,
    refferalCode: ''
  });
  const [userWallets, setUserWallets] = useState([]);

  useEffect(() => {
    fetchUserDetails();
    fetchUserWallets();
    fetchUserWmdrSummary();
  }, [id]);

  const fetchUserWmdrSummary = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/dashboard`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    errorHandler(response);

    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }
    setWmdrSummary(response.data['data']);
  };

  const fetchUserDetails = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/users/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    errorHandler(response);
    setUserDetails(response.data.data.user);
    setUserSummary(response.data.data.summary);
  };

  const fetchUserWallets = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/user/${id}/wallets`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    errorHandler(response);
    setUserWallets(response.data.data.cryptoWallet);
  };

  return (
    <div>
      <div className="mb-9">
        <Row className="d-flex align-items-center justify-content-between g-3 mb-4">
          <Col xs="auto">
            <h2 className="mb-0 flex-1">User details</h2>
          </Col>
          <Col xs="auto" className="d-flex gap-3 flex-wrap"></Col>
        </Row>
        <Row className="g-5">
          <Col xs={12} xxl={4}>
            <Row className="g-3 xxl-0">
              <Col xs={12} md={7} xxl={12}>
                <CustomerProfileCard
                  userDetails={userDetails}
                  summary={userSummary}
                />
              </Col>
              <Col xs={12} md={5} xxl={12}>
                <Card className="">
                  <Card.Body className="">
                    <div className="d-flex align-items-center mb-3">
                      <h3 className="me-1">Other Information</h3>
                      {/* <Button variant="link" className="p-0">
                        <FontAwesomeIcon
                          icon={faPen}
                          className="fs-8 ms-3 text-body-quaternary"
                        />
                      </Button> */}
                    </div>
                    {/* <h5 className="text-body-secondary">Address</h5>
                    <p className="text-body-secondary">
                      Shatinon Mekalan
                      <br />
                      Vancouver, British Columbia
                      <br />
                      Canada
                    </p> */}
                    <div className="mb-3">
                      <h5 className="text-body-secondary">User ID</h5>
                      <p className="text-body-secondary mb-0">
                        {userDetails?.userId}
                      </p>
                    </div>
                    <div className="mb-3">
                      <h5 className="text-body-secondary">Subscribe Email</h5>
                      <a
                        href={`mailto:${userDetails?.subscribeEmailId}`}
                        className="text-body-secondary"
                      >
                        {userDetails?.subscribeEmailId}
                      </a>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              {/* <Col xs={12}>
                <CustomerNotesCard className="h-100" />
              </Col> */}
            </Row>
          </Col>
          <Col xs={12} xxl={8}>
            <div className="d-flex flex-column gap-6">
              <div>
                <h3 className="mb-4">
                  Wallet{' '}
                  <span className="text-body-tertiary fw-normal">
                    ({userWallets.length})
                  </span>
                </h3>
                {<UserWalletTable userWallets={userWallets} />}
              </div>
              <UserNormalPointsReward />
              <UserReferralPointsReward />
              <UserRewardClaim />

              {/* <div>
                <h3 className="mb-4">
                  Ratings & reviews{' '}
                  <span className="text-body-tertiary fw-normal">(43)</span>
                </h3>
                <CustomerRatingsTable />
              </div> */}
            </div>
          </Col>
        </Row>
        {/* <div className="d-flex flex-between-center border-top border-dashed pt-4">
          <div>
            <h6>Referral Code</h6>
            <p className="fs-7 text-body-secondary mb-0">
              {userDetails?.refferalCode}
            </p>
          </div>
          <div className="">
            <h6>Projects</h6>
            <p className="fs-7 text-body-secondary mb-0">56</p>
          </div>
          <div className="">
            <h6>Completion</h6>
            <p className="fs-7 text-body-secondary mb-0">97</p>
          </div> 
        </div>*/}
      </div>
    </div>
  );
};

export default UserDetails;
